import { render, staticRenderFns } from "./IconPresentationChartBarSolid.vue?vue&type=template&id=016e2a56"
import script from "./IconPresentationChartBarSolid.vue?vue&type=script&lang=js"
export * from "./IconPresentationChartBarSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports